<app-spinner></app-spinner>
<!-- <div class="safe-area-ios" *ngIf="isIos"></div> -->
<ng-container *ngIf="canLoadApp">
    <app-header *ngIf="showHeader"></app-header>
    <main class="content-wrapper" [ngClass]="{'mnc-wrapper': isIos}" role="main" tabindex="-1">
            <router-outlet></router-outlet>
    </main>
    <app-scroll-to-top></app-scroll-to-top>
    <app-footer *ngIf="showFooter"></app-footer>
</ng-container>
